import LiveDot from "@/components/LiveDot";

/** Shared small status pill (same family as «تابعونا»): dark box, white text, red pulsing dot,
 *  thin slow teal beam. Width follows the content; text & box never move — only the ring and dot animate. */
export default function StatusBadge({ children, className = "", testId = "status-badge", as: Tag = "span", ...rest }) {
    return (
        <span className={`beam-ring beam-ring--slow beam-ring--badge rounded-[5px] follow-badge-ring status-badge-ring ${className}`}>
            <Tag className="live-badge status-badge" data-testid={testId} {...rest}>
                <LiveDot tone="red" testId={`${testId}-dot`} />
                <span className="status-badge__text">{children}</span>
            </Tag>
        </span>
    );
}
